<nav class="navbar">
  <div class="navbar-container">
    <div class="left-section">
      <div class="hallmark"></div>
    </div>

    <div class="navbar-brand">
      <h2>Exploration Tool Hub</h2>
    </div>

    <div class="nav-actions">
      <a
        *ngIf="isAdmin()"
        routerLink="/dashboard"
        routerLinkActive="active"
        class="nav-button"
      >
        Dashboard
      </a>
      <a
        *ngIf="isAdmin()"
        routerLink="/admin"
        routerLinkActive="active"
        class="nav-button"
      >
        Admin
      </a>

      <div class="app-header__account">
        <button
          type="button"
          class="app-header__identity"
          (click)="toggleMenu($event)"
          [attr.aria-expanded]="menuOpen"
          aria-haspopup="menu"
          aria-label="Open account menu"
        >
          <span class="app-header__greeting">Hello, {{ userName }}</span>
          <span class="app-header__avatar" aria-hidden="true">
            {{ userInitials }}
          </span>
          <span class="app-header__chevron" aria-hidden="true">&#9662;</span>
        </button>

        <div class="app-header__menu" role="menu" *ngIf="menuOpen">
          <button
            class="app-header__menu-item"
            role="menuitem"
            type="button"
            (click)="logout()"
          >
            Logout
          </button>
        </div>
      </div>
    </div>
  </div>
</nav>
